import styled, { css, createGlobalStyle } from 'styled-components';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import { StyledLeagueTrigger, StyledLeagueTriggerName, StyledLeagueChevron, StyledLeagueCrest, StyledLeagueNum } from '../LeagueSwitcher/styled';
import { StyledButton, StyledSectionContainer } from '../../globalStyled';
import { fontUi, sectionTitle } from '../../theme/typography';
import { themedSelectMenuCss, selectMenuCss } from '../../theme/selectStyles';

export const StyledSection = styled(StyledSectionContainer)`
  overflow: hidden;

  h3 {
    ${sectionTitle};
    width: 100%;
    font-size: 18px;
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledContainer = styled.div`
  padding: 16px 16px 20px;
  background: transparent;
`;
export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const StyledSelect = styled(Select)`
  flex: 1;
  min-width: 0;
  width: auto;
  margin-bottom: 16px;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  .send-money-select__control {
    height: 40px;
    min-height: 40px;
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.border};
    background-color: ${({ theme }) => theme.inset};
    ${fontUi};
    font-weight: 600;
    box-shadow: none;
    &--is-focused {
      border-color: ${({ theme }) => theme.textFaint};
    }
    &--is-disabled {
      background-color: ${({ theme }) => theme.hover};
      opacity: 0.7;
    }
  }
  .send-money-select__single-value,
  .send-money-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .send-money-select__indicator-separator {
    display: none;
  }

  .send-money-select__placeholder {
    ${fontUi};
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    color: ${({ theme }) => theme.textFaint};
  }
  .send-money-select__indicator {
    svg {
      width: 15px;
      fill: ${({ theme }) => theme.textFaint};
    }
  }
  ${selectMenuCss('send-money-select')}
`;

export const StyledInput = styled(NumberFormat)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  height: 40px;
  flex: 1;
  min-width: 0;
  width: auto;
  position: relative;
  background-color: ${({ theme }) => theme.inset};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 6px;
  ${fontUi};
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.015em;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  padding: 13px 43px 13px 8px;
  box-sizing: border-box;
  ::placeholder,
  ::-webkit-input-placeholder {
    ${fontUi};
    font-weight: 500;
    color: ${({ theme }) => theme.textFaint};
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export const StyledSendButton = styled(StyledButton)`
  flex: 1;
  min-width: 0;
  width: auto;
  margin-bottom: 0;
  margin: 0;
  box-shadow: none;
  &:disabled {
    box-shadow: none;
  }
  ${({ theme }) =>
    theme.isDark &&
    css`
      background: transparent;
      color: ${theme.text};
      border: 1px solid ${theme.border};
      &:disabled {
        background: transparent;
        color: ${theme.textFaint};
        border-color: ${theme.border};
      }
    `}
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledSelectItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  img {
    margin-right: 8px;
    position: relative;
    width: 18px;
  }
  span {
    font-size: 13px;
  }
`;

export const SendMoneyMenuStyle = createGlobalStyle`
  .send-money-select__menu-portal {
    ${selectMenuCss('send-money-select')}
    .send-money-select__menu {width:100%;max-width:calc(100vw - 24px);}
    .send-money-select__option {white-space:normal;}
  }
`;

// Reuse the League/Cup menu, but keep its trigger consistent with this form.
export const StyledLeagueField = styled.div`
  flex: 1;
  min-width: 0;
  margin-bottom: 16px;
  ${StyledLeagueTrigger} {
    ${fontUi};
    width: 100%;
    max-width: none;
    height: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid ${({theme})=>theme.border};
    background: ${({theme})=>theme.inset};
    color: ${({theme,$empty})=>$empty ? theme.textFaint : theme.text};
    font-size: 12px;
    font-weight: ${({$empty})=>$empty ? 500 : 600};
    backdrop-filter: none;
    &:hover, &:focus-visible {
      background: ${({theme})=>theme.inset};
      border-color: ${({theme})=>theme.textFaint};
    }
    &:focus-visible {outline: 2px solid ${({theme})=>theme.headerAccent};outline-offset: 2px;}
  }
  ${StyledLeagueNum} {color: ${({theme})=>theme.text};}
  ${StyledLeagueTriggerName} {flex: 1;}
  ${StyledLeagueChevron} {margin-left: auto;color: ${({theme})=>theme.textFaint};}
  ${({$empty})=>$empty && css`${StyledLeagueCrest} {display:none;}`}
  @media(max-width:768px) {width:100%;}
`;
